import theme from 'stories/theme';
import styled from 'styled-components';
import Container from 'ui/Container';

export const Wrapper = styled.div`
  min-height: calc(100vh - 61.5px);
  height: 100%;
  background: ${theme.colors.grey[700]};
  display: flex;
  justify-content: center;
  padding-top: 6rem;
  padding-bottom: 3rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-top: 3rem;
  }
`;

export const SubWrapper = styled(Container)`
  max-width: 375px;
  margin: 0 auto;
`;

export const Badge = styled.div`
  text-align: center;
  display: block;
  line-height: 1.33;
  font-size: ${({ theme }) => theme.spacing[3.5]};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.grey[400]};
  a text {
    text-decoration: underline;
  }
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  h2 {
    color: ${({ theme }) => theme.colors.grey[400]};
  }
  gap: ${({ theme }) => theme.spacing[4]};
`;
